import React from "react";
import { default as Spinner, SpinnerProps } from "react-spinkit";

interface IProps {
    // accepts values full (the default), half, quarter, and none for one second, a half second, a quarter second, and no fade in, respectively
    fadeIn?: SpinnerProps["fadeIn"];
}

export const LoadingSpinner = ({ fadeIn }: IProps): React.JSX.Element => {
    const _Spinner = Spinner as React.ComponentClass<SpinnerProps>;
    return (
        // TODO(i18n): Add aria-label for screen readers: aria-label={t`Loading`}
        <div className="loading-spinner l-capped-width">
            <div className="loading-spinner__inner">
                <_Spinner
                    name="three-bounce"
                    fadeIn={fadeIn ? fadeIn : "full"}
                />
            </div>
        </div>
    );
};
